import { PersonRole, CountersignRole } from "@ha/data/basic";

import { PermitPerson, PermitPersonWithStatus, RecentTeamMemberSort } from "../../shared/models/permit-person.model";
import { FindCertifiedPersonQuery, FireWatchersNotNeededCommand, RemovePersonFromPermitCommand, SearchPersonForPermitCommand, ToggleAllowSwitchingCommand } from "../models/permit-team-commands.model";

import { CreateCertificateCommand } from "../models/create-certificate-person.model";
import { SignPermitWithSignatureCommand } from "../models/sign-permit-with-signature-command";

export namespace PermitTeamActions {
    export class AddStagedPersonsToPermit {
        public static readonly type = "[PermitTeamActions] AddStagedPersonsToPermit";
        constructor(public permitId: number, public role: PersonRole) {}
    }

    export class ClearCreateCertificateResponse {
        public static readonly type = "[PermitTeamActions] ClearCreateCertificateResponse";
    }

    export class ClearCreatePersonFormData {
        public static readonly type = "[PermitTeamActions] ClearCreatePersonFormData";
    }

    export class CreateCertificateAndStagePerson {
        public static readonly type = "[PermitTeamActions] CreateCertificateAndStagePerson";
        constructor(public permitId: number, public role: PersonRole) {}
    }

    export class CreatePermitTeamTextMember {
        public static readonly type = "[PermitTeamActions] CreatePermitTeamTextMember";
        constructor(public permitId: number, public member: string) {}
    }

    export class CountersignPermit {
        public static readonly type = "[PermitTeamActions] CountersignaturePermit";
        constructor(public permitId: number, public member: string, public role: CountersignRole, public freeTextRole: string, public signature: string) {}
    }

    export class CreateNewCertificateAndStagePerson {
        public static readonly type = "[PermitTeamActions] CreateNewCertificateAndStagePerson";
        constructor(
            public permitId: number,
            public person: PermitPersonWithStatus,
            public command: CreateCertificateCommand,
        ) {}
    }

    export class FindPerson {
        public static readonly type = "[PermitTeamActions] FindPerson";
        constructor(public query: FindCertifiedPersonQuery) {}
    }

    export class FindPersonBA {
        public static readonly type = "[PermitTeamActions] FindPersonBA";
        constructor(public query: FindCertifiedPersonQuery) {}
    }

    export class GetRecentTeamMembers {
        public static readonly type = "[PermitTeamActions] GetRecentTeamMembers";
        constructor(
            public permitId: number,
            public take: number,
            public includeColleagues: boolean,
            public includeSharedFromPremium: boolean,
            public sort: RecentTeamMemberSort,
            public sortByDescending: boolean,
            public restart: boolean = false,
            public query: string = "",
        ) {}
    }

    export class GetTeam {
        public static readonly type = "[PermitTeamActions] GetTeam";
        constructor(public permitId: number) {}
    }

    export class RemovePerson {
        public static readonly type = "[PermitTeamActions] RemovePerson";
        constructor(public command: RemovePersonFromPermitCommand) {}
    }

    export class ResetFind {
        public static readonly type = "[PermitTeamActions] ResetFind";
    }

    export class ResetNewPersonForm {
        public static readonly type = "[PermitTeamActions] ResetNewPersonForm";
    }

    export class ResetNewPersonResponse {
        public static readonly type = "[PermitTeamActions] ResetNewPersonResponse";
    }

    export class ResetNewPersonFormKeepCertId {
        public static readonly type = "[PermitTeamActions] ResetNewPersonFormKeepCertId";
    }

    export class SetConcept {
        public static readonly type = "[PermitTeamActions] SetConcept";
        constructor(public concept: number) {}
    }

    export class SetNewPersonForm {
        public static readonly type = "[PermitTeamActions] SetNewPersonForm";
        constructor(public person: PermitPersonWithStatus) {}
    }

    export class SetNewPersonFormBA {
        public static readonly type = "[PermitTeamActions] SetNewPersonFormBA";
        constructor(public person: PermitPersonWithStatus) {}
    }

    export class SetPersonalNumber {
        public static readonly type = "[PermitTeamActions] SetPersonalNumber";
        constructor(public personalNumber: string) {}
    }

    export class SetHasForeignPersonalNumber {
        public static readonly type = "[PermitTeamActions] SetHasNoPersonalNumber";
        constructor(public hasForeignPersonalNumber: boolean) {}
    }

    export class SetEmail {
        public static readonly type = "[PermitTeamActions] SetEmail";
        constructor(public email: string) {}
    }

    export class SetCertificateIdentifier {
        public static readonly type = "[PermitTeamActions] SetCertificateIdentifier";
        constructor(public certificateIdentifier: string) {}
    }

    export class ToggleAllowSwitching {
        public static readonly type = "[PermitTeamActions] ToggleAllowSwitching";
        constructor(public command: ToggleAllowSwitchingCommand) {}
    }

    export class SearchPersonForPermit {
        public static readonly type = "[PermitTeamActions] SearchPersonForPermit";
        constructor(public command: SearchPersonForPermitCommand) {}
    }

    export class SetFireWatchersNotNeeded {
        public static readonly type = "[PermitTeamActions] SetFireWatcherNotNeeded";
        constructor(public command: FireWatchersNotNeededCommand) {}
    }

    export class SetAddPersonView {
        public static readonly type = "[PermitTeamActions] SetAddPersonView";
        constructor(public role: PersonRole) {}
    }

    export class SignPermitWithSignature {
        public static readonly type = "[PermitTeamActions] SignPermitWithSignature";
        constructor(public command: SignPermitWithSignatureCommand) {}
    }

    export class StagePerson {
        public static readonly type = "[PermitTeamActions] StagePerson";
        constructor(public person: PermitPerson) {}
    }

    export class UnstageAll {
        public static readonly type = "[PermitTeamActions] UnstageAll";
    }

    export class UnstagePerson {
        public static readonly type = "[PermitTeamActions] UnstagePerson";
        constructor(public certificateId: number) {}
    }
}
